import { ReactNode, createContext, useState } from "react";
import { Car } from "@models/car";

interface CarContextType {
  car: Car | null;
  setCar: (car: Car) => void;
}

export const CarContext = createContext<CarContextType>({
  car: null,
  setCar: () => {},
});

export const CarProvider: React.FC<{ children: ReactNode; car: Car }> = ({ children, car }) => {
  const [currentCar, setCurrentCar] = useState<Car>(car);

  return <CarContext.Provider value={{ car: currentCar, setCar: setCurrentCar }}>{children}</CarContext.Provider>;
};
